// Validated query-param parsing + search-string merging for URL-synced view state.

export function getStringParam(search, key, { fallback = '', allowed = null } = {}) {
  const v = new URLSearchParams(search).get(key);
  if (v === null || v === '') return fallback;
  if (allowed && !allowed.includes(v)) return fallback;
  return v;
}

export function getIntParam(search, key, { fallback = null, min = -Infinity, max = Infinity } = {}) {
  const raw = new URLSearchParams(search).get(key);
  if (raw === null || raw === '') return fallback;
  const n = Number(raw);
  if (!Number.isInteger(n) || n < min || n > max) return fallback;
  return n;
}

export function getDateParam(search, key) {
  const v = new URLSearchParams(search).get(key);
  if (!v || !/^\d{4}-\d{2}-\d{2}$/.test(v)) return null;
  const [y, m, d] = v.split('-').map(Number);
  const date = new Date(Date.UTC(y, m - 1, d));
  const valid = date.getUTCFullYear() === y && date.getUTCMonth() === m - 1 && date.getUTCDate() === d;
  return valid ? v : null;
}

// Validates a post-login redirect target: only same-app absolute paths are
// allowed ('/x...'); protocol-relative ('//evil.com') and external URLs are
// rejected so ?next= can never become an open redirect. Backslashes and
// control characters are refused too: browsers read '/\evil.com' and
// '/\t/evil.com' as '//evil.com'.
export function getSafeInternalPath(raw) {
  if (typeof raw !== 'string') return null;
  if (!raw.startsWith('/') || raw.startsWith('//')) return null;
  // eslint-disable-next-line no-control-regex
  if (/[\\\u0000-\u001f\u007f]/.test(raw)) return null;
  return raw;
}

// updates: { key: value | null } - null/undefined/'' deletes the key.
// Returns '?k=v&...' or '' so it can be compared to location.search directly.
export function mergeSearch(search, updates) {
  const params = new URLSearchParams(search);
  Object.entries(updates).forEach(([key, value]) => {
    if (value === null || value === undefined || value === '') params.delete(key);
    else params.set(key, String(value));
  });
  const s = params.toString();
  return s ? `?${s}` : '';
}
